import { InMemoryCacheConfig } from "@apollo/client";

export const CART_APOLLO_CACHE_CONFIG: InMemoryCacheConfig = {
  typePolicies: {
    Query: {
      fields: {
        cart: {
          merge: true,
        },
      },
    },
    CartParcel: {
      fields: {
        items: {
          merge: false,
        },
      },
    },
    CartClubSubscriptionOption: {
      keyFields: ["id", "price", ["amount"]],
    },
  },
};
